export interface QuizSessionNavigationState {
  questionIndex: number
  lastIndex: number
}

export function initialQuizSessionQuestionTimes(questionCount: number): QuizSessionQuestionTimesState {
  return Array(questionCount).fill(null)
}

export type QuizSessionQuestionTimesState = (QuestionTime | null)[]
interface QuestionTime {
  firstShownTime: Date
  seconds: number
}

export function initialQuizSessionQuestionStates(questionCount: number): QuizSessionQuestionStatesState {
  return Array(questionCount).fill(null)
}

export type QuizSessionQuestionStatesState = (QuizSessionQuestionState | null)[]
export interface QuizSessionQuestionState {
  type: string
  state: { value: unknown } | null
  answer: { value: unknown } | null
  phase: QuestionPhase
  result: {
    score: number
  }
  // /** @deprecated */
  // evaluated: boolean
  // /** @deprecated */
  // showSolution: boolean
}

export type QuestionPhase = 'not-answered' | 'answered' | 'evaluated' | 'solution-shown'
